import { createSelector } from 'reselect';

const calendarPath = state => state.calendar;

export const selectedCalendarDate = createSelector(
  calendarPath,
  calendar => calendar.selectedCalendarDate,
);
